import { Pipe, PipeTransform, ElementRef, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

@Pipe({
  name: 'routerLink'
})
export class RouterLinkPipe implements PipeTransform {
  constructor(private el: ElementRef,
    private router: Router, private renderer: Renderer2) {

  }
  clickListeners = [];
  transform(value: any, args?: any): any {
    const anchorNodes = this.el.nativeElement.querySelectorAll('p');
    const anchors = Array.from(anchorNodes);
    anchors.forEach((anchor: any) => {
      let listener = this.renderer.listen(anchor, 'click', e => {
        e.preventDefault();
        let href = e.srcElement.getAttribute('href');
        if (href) {
          this.router.navigate([href.replace("brand/","").replace("user/","").replace("product/","")]);
        }
      });
      this.clickListeners.push(listener);
    });
    return value;
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_pipe/router-link.pipe.ts